import { Row, Col } from 'styled-bootstrap-grid';
import { styled } from 'styled-components';

import { Media } from '../../theme/Media.tsx';

const FormGroup = styled(Row)`
  margin-bottom: 15px;
`;

const InnerCol = styled(Col)`
  margin-bottom: 15px;
  @media ${Media.smMin} {
    margin-bottom: 0;
  }
`;

const InnerGroup = styled.div<{ $disabledSpacer?: boolean }>`
  margin-bottom: ${({ $disabledSpacer }) => !$disabledSpacer && '15px'};
`;

export { FormGroup, InnerGroup, InnerCol };
